// @ts-ignore
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import ReactApexChart from "react-apexcharts";

export const BarChart = ({ labels, values, name }) => {
  return (
    <ReactApexChart
      options={{
        chart: {
          type: "bar",
          height: 250,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
          foreColor: "#8a919c",
          fontFamily: "Inter, sans-serif",
          parentHeightOffset: 0,
        },

        grid: {
          borderColor: "#eef0f3",
          strokeDashArray: 3,
          padding: { left: 4, right: 4 },
          xaxis: { lines: { show: false } },
        },

        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 4,
            borderRadiusApplication: "end",
            borderRadiusWhenStacked: "last",
          },
        },
        states: {
          hover: { filter: { type: "darken", value: 0.9 } },
          active: { filter: { type: "none" } },
        },
        xaxis: {
          type: "string",
          categories: labels,
          labels: {
            style: {
              fontSize: "11px",
              fontFamily: "inherit",
            },
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          title: {
            style: {
              fontSize: "11px",
              fontFamily: "inherit",
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: "11px",
              fontFamily: "inherit",
            },
            formatter: (v) =>
              typeof v === "number" && Number.isInteger(v)
                ? v.toLocaleString()
                : v,
          },
          title: {
            style: {
              fontSize: "11px",
              fontFamily: "inherit",
            },
          },
        },
        legend: {
          show: false,
        },
        tooltip: {
          theme: "light",
          y: { formatter: (v) => (typeof v === "number" ? v.toLocaleString() : v) },
        },

        colors: ["#e11d24"],
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
      }}
      series={[
        {
          name,
          data: values,
        },
      ]}
      type="bar"
      height={240}
    />
  );
};
